module.exports = __webpack_public_path__ + "assets/img/SAI-block-299.97516998.png";